export default __webpack_public_path__ + "static/media/patchwork.3b1ff228.png";